import api from "@/config/api";
import { handleApiError } from "@/utils/ErrorHandler";
import { createPaginationModule, defaultPagination } from "@/store/common/pagination";

const usersSummaryPag = createPaginationModule('USERS_SUMMARY');

const state = {
    usersSummary: [],
    pagination: defaultPagination(),
    loading: false,
    error: null,
};

const mutations = {
    ...usersSummaryPag.mutations,

    SET_USERSSUMMARY(state, usersSummary) {
        state.usersSummary = usersSummary;
    },
    SET_LOADING(state, val) {
        state.loading = val;
    },
    SET_ERROR(state, err) {
        state.error = err;
    },
};

const actions = {
    /**
     * ✅ Fetch paginated users summary
     * API: GET /api/manage-user?locationid={id}&cmd=summary&max={pageSize}&offset={page}&search={query}
     */
    async fetchUsersSummary(
        { commit },
        { locationId, page = 1, pageSize = 30, search = "" }
    ) {
        commit("SET_LOADING", true);
        commit("SET_ERROR", null);

        try {
            const response = await api.get("/manage-user", {
                params: {
                    locationid: locationId,
                    cmd: "summary",
                    page_size: pageSize,
                    page_number: page,
                    search,
                },
            });

            const { users, pagination } = response.data.data

            const normalized = users.map((u) => ({
                ...u,
                interestskills: Array.isArray(u.interestskills) ? u.interestskills : [],
                preferredActivitiesWorkgroups: Array.isArray(u.preferredActivitiesWorkgroups)
                    ? u.preferredActivitiesWorkgroups
                    : [],
            }));

            commit("SET_USERSSUMMARY", normalized);
            commit(usersSummaryPag.SET_PAGINATION,
                {
                    currentPage: pagination.current_page,
                    totalPages: pagination.total_pages,
                    totalRecords: pagination.total_records,
                    pageSize: pagination.page_size,
                    hasPrevious: pagination.has_previous,
                    hasNext: pagination.has_next,
                });

            return users;
        } catch (error) {
            const message = handleApiError(error, "Failed to fetch users summary");
            commit("SET_ERROR", message);
            throw new Error(message);
        } finally {
            commit("SET_LOADING", false);
        }
    },
};

const getters = {
    allUsersSummary: (state) => state.usersSummary,
    usersSummaryPagination: (state) => state.pagination,
    usersSummaryLoading: (state) => state.loading,
};

export default {
    state,
    mutations,
    actions,
    getters,
};